import { defineComponent as a, computed as o, openBlock as d, createBlock as i, resolveDynamicComponent as c, normalizeClass as u, withCtx as m, renderSlot as p } from "vue";
import { tw as r } from "../../utils/tailwind.js";
const _ = /* @__PURE__ */ a({
  name: "RevAccordionList",
  __name: "AccordionList",
  props: {
    hasExternalBorders: { type: Boolean, default: !0 },
    listType: { default: "unordered" }
  },
  setup(s) {
    const e = s, l = o(() => [
      r`divide-static-default-low list-none divide-y`,
      e.hasExternalBorders && r`border-static-default-low border-y`
    ]), n = o(() => ({
      unordered: "ul",
      ordered: "ol"
    })[e.listType]);
    return (t, f) => (d(), i(c(n.value), {
      class: u(l.value)
    }, {
      default: m(() => [
        p(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  _ as default
};
